import React__default from 'react';
import styled from 'styled-components';
import Box from '../../components/Box/Box.js';
import { get } from '../../constants.js';
import sx from '../../sx.js';
import Text from '../../components/Text/Text.js';

/**
 * Provides a visual indicator that a user has added a script or filter to an item. Use with a RuleFilter.
 */
const RuleFilterTag = ({
  children,
  validationStatus = 'default',
  isBold = false,
  leadingVisual: LeadingVisual,
  trailingVisual: TrailingVisual,
  testId,
  sx,
  ...props
}) => {
  const hasLeadingVisual = Boolean(LeadingVisual);
  const hasTrailingVisual = Boolean(TrailingVisual);
  return /*#__PURE__*/React__default.createElement(Wrapper, {
    as: "span",
    "data-testid": testId,
    isBold: isBold,
    validationStatus: validationStatus,
    sx: sx
  }, ' ', hasLeadingVisual ? /*#__PURE__*/React__default.createElement(InnerVisualSlot, {
    isBold: isBold,
    validationStatus: validationStatus
  }, typeof LeadingVisual === 'function' ? /*#__PURE__*/React__default.createElement(LeadingVisual, null) : LeadingVisual) : null, /*#__PURE__*/React__default.createElement(Label, {
    isBold: isBold,
    validationStatus: validationStatus
  }, children), hasTrailingVisual ? /*#__PURE__*/React__default.createElement(InnerVisualSlot, {
    isBold: isBold,
    validationStatus: validationStatus
  }, typeof TrailingVisual === 'function' ? /*#__PURE__*/React__default.createElement(TrailingVisual, null) : TrailingVisual) : null);
};
RuleFilterTag.displayName = "RuleFilterTag";
const Wrapper = styled(Box).withConfig({
  displayName: "RuleFilterTag__Wrapper",
  componentId: "sc-22ktv3-0"
})(["display:inline-flex;border-radius:", ";padding-inline:", ";padding-inline-end:", ";gap:", ";align-items:center;background-color:", ";", ";"], get('radii.2'), get('space.2'), get('space.1'), get('space.1'), p => p.validationStatus === 'default' && p.isBold ? get('colors.background.neutral.bold.default') : p.validationStatus === 'success' && p.isBold ? get('colors.background.information.bold.default') : p.validationStatus === 'error' && p.isBold ? get('colors.background.danger.bold.default') : p.validationStatus === 'warning' && p.isBold ? get('colors.background.warning.bold.default') : p.validationStatus === 'default' ? get('colors.background.neutral.default.[default]') : p.validationStatus === 'success' ? get('colors.background.information.default.[default]') : p.validationStatus === 'error' ? get('colors.background.danger.default.[default]') : p.validationStatus === 'warning' ? get('colors.background.warning.default.[default]') : 'revert', sx);
const InnerVisualSlot = styled(Box).withConfig({
  displayName: "RuleFilterTag__InnerVisualSlot",
  componentId: "sc-22ktv3-1"
})(["display:block;color:", ";svg{}", ";"], p => p.validationStatus === 'default' && p.isBold ? get('colors.text.inverse') : p.validationStatus === 'success' && p.isBold ? get('colors.text.inverse') : p.validationStatus === 'error' && p.isBold ? get('colors.text.inverse') : p.validationStatus === 'warning' && p.isBold ? get('colors.text.warning.inverse') : p.validationStatus === 'default' ? get('colors.text.default') : p.validationStatus === 'success' ? get('colors.text.information') : p.validationStatus === 'error' ? get('colors.text.danger') : p.validationStatus === 'warning' ? get('colors.text.warning.default') : 'revert', sx);
const Label = styled(Text).withConfig({
  displayName: "RuleFilterTag__Label",
  componentId: "sc-22ktv3-2"
})(["font-size:", ";line-height:", ";width:100%;color:", ";", ";"], get('fontSizes.2'), get('lineHeights.default'), p => p.validationStatus === 'default' && p.isBold ? get('colors.text.inverse') : p.validationStatus === 'success' && p.isBold ? get('colors.text.inverse') : p.validationStatus === 'error' && p.isBold ? get('colors.text.inverse') : p.validationStatus === 'warning' && p.isBold ? get('colors.text.warning.inverse') : p.validationStatus === 'success' ? get('colors.text.default') : p.validationStatus === 'error' ? get('colors.text.danger') : p.validationStatus === 'warning' ? get('colors.text.warning.default') : 'revert', sx);
RuleFilterTag.displayName = 'RuleFilterTag';

export { RuleFilterTag };
